// import '../App.css';
// import logo from '../assets/images/banner-logo.png';
// import barbershop from '../assets/images/open-hours-logo.png';

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../App.css";

function About() {
  const [acf, setAcf] = useState(null);
  const [showBooking, setShowBooking] = useState(false);

  useEffect(() => {
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14")
      .then((res) => res.json())
      .then((json) => setAcf(json.acf))
      .catch((err) => console.error("Error fetching ACF data:", err));
  }, []);

  if (!acf) return null;

  return (
    <div id="about" className="section">
      <div
        className="banner"
        style={{
          backgroundImage: acf.about_background_image?.url
            ? `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${acf.about_background_image.url})`
            : "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6))", // fallback so div still renders
        }}

      >
        {acf.banner_logo && (
          <img src={acf.banner_logo.url} alt={acf.banner_logo.alt || "Logo"} />
        )}
        <motion.div initial="hidden" animate="show" className="motion-div-layer">
          <motion.h1
            whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
            initial={{ y: 80, opacity: 1 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {acf.banner_title || "Family Barbers"}
          </motion.h1>

          <motion.h3
            whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
            initial={{ y: 50, opacity: 1 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {acf.banner_subtitle || "Barbershop"}
          </motion.h3>
        </motion.div>
        <motion.button
          className="book-now about-btn book-now-layer"
          onClick={() => {
            if (window.innerWidth < 1024) {
              window.open("https://getsquire.com/booking/brands/family-barbers", "_blank");
            } else {
              setShowBooking(!showBooking);
            }
          }}
          whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
          initial={{ boxShadow: "0 0 0px rgba(255,255,255,0)" }}
          animate={{
            boxShadow: [
              "0 0 0px rgba(255,255,255,0)",
              "0 0 20px rgba(255,255,255,0.8)",
              "0 0 0px rgba(255,255,255,0)",
            ],
          }}
          transition={{ duration: 0.2, repeat: 4, repeatType: "loop" }}
        >
          <span>{acf.banner_button_text || "BOOK NOW!"}</span>
        </motion.button>


      </div>

      <div className="about-parent-container">
        <div className="about-child-container">
          <h3 className="about-us-h3">{acf.about_heading || "ABOUT US"}</h3>
          <div className="about-us-underline underline"></div>
          <motion.h2 className="about-us-h2"
            whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
            initial={{ x: -200, opacity: 1 }}       // Start off-screen left
            animate={{ x: 0, opacity: 1 }}          // End in place, fully visible
            transition={{ duration: 0.8, ease: "easeOut" }} // Animation settings
          >
            {acf.about_title || "A Traditional"}{" "}
            <span>{acf.about_title_span || "Barbershop"}</span>
          </motion.h2>

          <p className="about-us-p">
            <span>{acf.about_paragraph_1 || "Default paragraph 1"}</span>
            <span>{acf.about_paragraph_2 || "Default paragraph 2"}</span>
            <span>{acf.about_paragraph_3 || "Default paragraph 3"}</span>
          </p>

          <button
            className="book-now"
            onClick={() => {
              if (window.innerWidth < 1024) {
                // On small screens, go straight to booking page
                window.open("https://getsquire.com/booking/brands/family-barbers", "_blank");
              } else {
                // On desktop, toggle the popup modal
                setShowBooking(!showBooking);
              }
            }}
          >
            <span>{acf.about_button_text || "BOOK NOW!"}</span>
          </button>

          {/* Booking Popup */}
          {showBooking && (
            <div className="booking-modal">
              <div className="booking-content">
                <button className="close-btn" onClick={() => setShowBooking(!showBooking)}>
                  ✖
                </button>
                <iframe
                  src="https://getsquire.com/booking/brands/family-barbers"
                  style={{ width: "100%", height: '95vh', border: "none" }}
                  title="Squire Booking"
                ></iframe>
              </div>
            </div>
          )}

        </div>

        <div className="about-child-container-2">
          <div className="about-child-container-2-bg">
            <div className="open-hours">
              <motion.div
                whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
                initial={{ x: -200, opacity: 1 }}       // Start off-screen left
                animate={{ x: 0, opacity: 1 }}          // End in place, fully visible
                transition={{ duration: 0.8, ease: "easeOut" }} // Animation settings
              >
                {acf.open_hours_logo && (
                  <img
                    src={acf.open_hours_logo.url}
                    alt={acf.open_hours_logo.alt || "Logo"}
                  />
                )}
              </motion.div>
              <h2>{acf.open_hours_heading || "Open Hours"}</h2>
              <div className="open-hours-underline"></div>

              <h3>{acf.open_hours_mon_fri || "Monday - Friday: 10am - 8pm"}</h3>
              <h3>{acf.open_hours_sat || "Saturday: 9am - 9pm"}</h3>
              <h3>{acf.open_hours_sun || "Sunday: 12pm - 5pm"}</h3>
              <h3>{acf.walk_in_days || "Tue & Wed - (Walk In Days)"}</h3>

              <h2>{acf.shop_heading || "Shop"}</h2>
              <div className="open-hours-underline"></div>
              <h3>{acf.shop_address || "34A Dundas St E, Mississauga, ON L5A 1W2"}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
